import React, { memo } from 'react';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import { REPORT_CURRENCIES } from '../../../constants';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';
import { useFormatDateByLocale } from '../../../util/hooks/useFormatDateByLocale';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingCustom({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const { currency, asOfDate1 } = reportSnapshot;
  const formattedAsOfDate = useFormatDateByLocale(asOfDate1);

  return (
    <>
      <Styled.ReportSettingItem>
        <Icon name="currency" />
        <GStyled.Text>Currency</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {REPORT_CURRENCIES[currency].label}
        </GStyled.Text>
      </Styled.ReportSettingItem>
      <Styled.ReportSettingItem>
        <Icon name="calendar" />
        <GStyled.Text>Report Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">{formattedAsOfDate}</GStyled.Text>
      </Styled.ReportSettingItem>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
    </>
  );
}

export default memo(ReportSettingCustom);
